var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map-pin",
    clipPath: "url(#clip0_182_107924)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 5.96015C10 8.92444 6 11.6744 6 11.6744C6 11.6744 2 8.92444 2 5.96015C2 4.82351 2.42143 3.73342 3.17157 2.9297C3.92172 2.12597 4.93913 1.67444 6 1.67444C7.06087 1.67444 8.07828 2.12597 8.82843 2.9297C9.57857 3.73342 10 4.82351 10 5.96015Z",
    stroke: "#458378",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6 7.17444C6.82843 7.17444 7.5 6.50287 7.5 5.67444C7.5 4.84601 6.82843 4.17444 6 4.17444C5.17157 4.17444 4.5 4.84601 4.5 5.67444C4.5 6.50287 5.17157 7.17444 6 7.17444Z",
    stroke: "#458378",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_182_107924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.674438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.fac1c141250f9275e12847c618e33893.svg";
export { ForwardRef as ReactComponent };